<template>
  <v-footer class="footer-wrapper">
    <!-- Contenido principal -->
    <v-container class="footer-main-content">
      <!-- Logo y descripción -->
      <div class="footer-section">
        <div class="logo-container">
          <v-img
              src="@/assets/logo1.png"
              alt="Logo Energía Renovable"
              max-height="60"
              max-width="200"
              contain
          ></v-img>
        </div>
        <p class="footer-description">
          Soluciones innovadoras en energía renovable para un futuro sostenible.
        </p>
        <div class="social-icons">
          <v-btn
              v-for="(social, index) in socialMedia"
              :key="index"
              :icon="social.icon"
              variant="text"
              size="small"
              :color="social.color"
              class="social-icon"
              :href="social.link"
              target="_blank"
          ></v-btn>
        </div>
      </div>

      <!-- Enlaces rápidos -->
      <div class="footer-section">
        <h3 class="section-title">Enlaces Rápidos</h3>
        <ul class="footer-links">
          <li v-for="(link, index) in quickLinks" :key="index">
            <router-link :to="link.route" class="footer-link">
              <v-icon small class="link-icon">mdi-chevron-right</v-icon>
              {{ link.text }}
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Servicios -->
      <div class="footer-section">
        <h3 class="section-title">Nuestros Servicios</h3>
        <ul class="footer-links">
          <li v-for="(service, index) in services" :key="index">
            <router-link :to="service.route" class="footer-link">
              <v-icon small class="link-icon">mdi-chevron-right</v-icon>
              {{ service.text }}
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Contacto -->
      <div class="footer-section">
        <h3 class="section-title">Contacto</h3>
        <ul class="contact-info">
          <li class="contact-item">
            <v-icon class="contact-icon">mdi-map-marker</v-icon>
            <span>6661 SW 137 CT
UNIT D
MIAMI, FL 33183</span>
          </li>
          <li class="contact-item">
            <v-icon class="contact-icon">mdi-email</v-icon>
            <span>webmaster@sheshisam.com</span>
          </li>
          <li class="contact-item">
            <v-icon class="contact-icon">mdi-phone</v-icon>
            <div><span>+1 305 784 2400</span></div>


          </li>
          <li class="contact-item">
            <v-icon class="contact-icon"></v-icon>
            <div><span>+53 52013602</span></div>


          </li>
          <li class="contact-item">
            <v-icon class="contact-icon">mdi-clock</v-icon>
            <span>Lun-Vie: 8:00 AM - 6:00 PM</span>
          </li>
        </ul>
      </div>
    </v-container>

    <!-- Barra de copyright - Ahora completamente abajo y centrada -->
    <div class="copyright-bar">
      <v-container class="copyright-content">
        <span>&copy; {{ new Date().getFullYear() }} SHESHISAM Services Corp
. Todos los derechos reservados.</span>
        <div class="legal-links">
          <router-link to="/politica-privacidad" class="legal-link">Política de Privacidad</router-link>
          <span class="divider">|</span>
          <router-link to="/terminos-servicio" class="legal-link">Términos de Servicio</router-link>
        </div>
      </v-container>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      socialMedia: [
        { icon: 'mdi-facebook', color: '#3b5998', link: 'https://www.facebook.com/profile.php?id=61570358939179&mibextid=rS40aB7S9Ucbxw6v' },
         { icon: 'mdi-youtube', color: '#f21d36', link: 'https://youtube.com/@sheshisam?si=4u8UVYim4pDKvzv7' },
        // { icon: 'mdi-linkedin', color: '#0077b5', link: '#' },
        { icon: 'mdi-instagram', color: '#e1306c', link: 'https://www.instagram.com/sheshisamcorp.services?igsh=M29ucnNoaWJzbmV3' },
        // { icon: 'mdi-youtube', color: '#ff0000', link: '#' }
      ],
      quickLinks: [
        { text: "Inicio", icon: "mdi-home", section: "inicio" },
        { text: "Servicios", icon: "mdi-cog", section: "servicios" },
        { text: "Nuestros Proyectos", icon: "mdi-phone", section: "galeria" },
        { text: "Contacto", icon: "mdi-phone", section: "contacto" },
      ],
      services: [
        { text: 'Energía Solar', route: '/servicios/solar' },
        // { text: 'Energía Eólica', route: '/servicios/eolica' },
        { text: 'Consultoría Energética', route: '/servicios/consultoria' },
        { text: 'Almacenamiento', route: '/servicios/almacenamiento' },
        { text: 'Autoconsumo', route: '/servicios/autoconsumo' },
        { text: 'Monitorización', route: '/servicios/monitorizacion' }
      ]
    }
  }
}
</script>

<style scoped>
/* Estilos base consistentes */
.footer-wrapper {
  background-color: #0C594B;
  color: white;
  padding: 60px 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.footer-main-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px 40px;
  width: 100%;
}

.footer-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #ffffff;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #0A9A8A;
}

.footer-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 16px 0;
}

/* Logo */
.logo-container {
  margin-bottom: 16px;
  filter: brightness(0) invert(1);
}

/* Listas de enlaces */
.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.footer-link:hover {
  color: #0A9A8A;
}

.link-icon {
  margin-right: 8px;
  color: #0A9A8A;
}

/* Información de contacto */
.contact-info {
  list-style: none;
  padding: 0;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

.contact-icon {
  margin-right: 12px;
  color: #0A9A8A;
  flex-shrink: 0;
}

/* Iconos sociales */
.social-icons {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.social-icon {
  transition: transform 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-3px);
}

/* Barra de copyright - Ahora completamente abajo */
.copyright-bar {
  width: 100%;
  background-color: #083f36;
  padding: 20px 0;
  margin-top: auto; /* Esto empuja la barra hacia abajo */
}

.copyright-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  padding: 0 24px;
}

.legal-links {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  align-items: center;
}

.divider {
  color: rgba(255, 255, 255, 0.3);
}

/* Responsive */
@media (min-width: 768px) {
  .copyright-content {
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }

  .legal-links {
    margin-top: 0;
  }
}

@media (max-width: 600px) {
  .footer-main-content {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 0 16px 30px;
  }

  .section-title {
    font-size: 1.2rem;
  }

  .copyright-content {
    flex-direction: column;
  }

  .legal-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>